import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class ResultsHeader extends Component {
  static propTypes = {
    eventTitle: PropTypes.string.isRequired,
    order: PropTypes.string.isRequired,
    totalResults: PropTypes.number.isRequired,
    setOrder: PropTypes.func.isRequired,
  }

  setOrder = (e) => this.props.setOrder(e.target.value)

  render () {
    const { eventTitle, order, totalResults } = this.props
    if(this.props.isResultForBookingManagement == null){
        return (
      <>
        <h1 className='heading--lightweight text-medium'>Take a look at our large range of accommodation for rent in  <span>“{eventTitle}”</span> and find the perfect apartment, hotel or villa for your next corporate event.
</h1>

        <div className='map-listing__details'>
          <div className='map-listing__details__results'>
            {totalResults} results found. Use the filters above to refine your search.
          </div>

          <div className='map-listing__details__sorting'>
            <div className='form__group form__group form__group--inline'>
              <label className='form__label' htmlFor='search-order'>
                <strong className='text-secondary'>Sort by:</strong>
              </label>
              <div className='form__control form__control--outline form__control--select'>
                <select id='search-order' onChange={this.setOrder} value={order}>
                  <option value='featured' />
                  <option value='distance'>Closest first</option>
                  <option value='budget'>Budget (low-high)</option>
                  <option value='-budget'>Budget (high-low)</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </>
    )

    }
    else{
      // search results for the booking management page ( we do not need the order by drop-down)
         return (
      <>
        <h1 className='text-medium heading--lightweight'>Your booking for  <span>“{eventTitle}”</span>
</h1>

        <div className='map-listing__details'>
          <div className='map-listing__details__results'>
            {totalResults} bookings. Use the filter button to refine your booking view.
          </div>
        </div>
      </>
    )
    }


  }
}



// WEBPACK FOOTER //
// ./src/components/ResultsHeader.js